import styles from './EditOrCreateModal.module.css';

function EditOrCreateModal({ isOpen, onClose, type, schemaTitle, existingDefinitions = [], onEdit, onCreate }) {
    if (!isOpen) return null;

    const typeLabel = type === 'stain' ? 'stain' : 'region';

    return (
        <div 
            className={styles.modalOverlay}
            onClick={onClose}
        >
            <div 
                className={styles.modalContent}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={styles.modalHeader}>
                    <h3 className={styles.modalTitle}>
                        Edit existing {typeLabel} or create new?
                    </h3>
                    <button 
                        className={styles.closeButton}
                        onClick={onClose}
                        title="Close"
                    >
                        ×
                    </button>
                </div>
                
                <div className={styles.modalBody}>
                    <p className={styles.schemaInfo}>
                        Schema: <strong>{schemaTitle}</strong>
                    </p>
                    
                    {existingDefinitions.length > 0 && (
                        <div className={styles.existingSection}>
                            <h4 className={styles.sectionTitle}>Existing {typeLabel} definitions:</h4>
                            <div className={styles.definitionsList}>
                                {existingDefinitions.map((def) => (
                                    <button
                                        key={def._id}
                                        className={styles.definitionItem}
                                        onClick={() => {
                                            onEdit(def._id);
                                            onClose();
                                        }}
                                    >
                                        <span className={styles.definitionName}>
                                            {def.longName || def.name || 'Unnamed'}
                                        </span>
                                        {def.name && def.name !== (def.longName || def.name) && (
                                            <span className={styles.definitionAbbr}>
                                                ({def.name})
                                            </span>
                                        )}
                                        {def.description && (
                                            <span className={styles.definitionDesc}>
                                                {def.description}
                                            </span>
                                        )}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                <div className={styles.modalFooter}>
                    <button
                        className={styles.createButton}
                        onClick={() => {
                            onCreate();
                            onClose();
                        }}
                    >
                        Create New {typeLabel.charAt(0).toUpperCase() + typeLabel.slice(1)}
                    </button>
                    <button
                        className={styles.cancelButton}
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
}

export default EditOrCreateModal;
